import {Col, ColType, Crud, CrudAction, CrudApi,CrudOption} from "../../comp/crud";
import {
    ApiClient, displayLeadStatus, displayMortgageLoanType,
    displayRepaymentPlanStatus,
    getRepaymentPlanStatusOpt,
    getPaidMethodOpt,
    displayPaidMethod
} from "../../api/ApiClient";
import React, {useContext, useEffect, useState} from "react";
import {Form, Modal, Typography, Toast, Tooltip,Image} from '@douyinfe/semi-ui';
import {FormApi} from "@douyinfe/semi-ui/lib/es/form";
import {formatAmountZhCn, formatDate,  renderPaidMethodTag, renderPeriodNo, renderRepaymentPlanStatusTag,renderPlatformTooltip} from "../../utils";
import {IconModalStroked} from "@douyinfe/semi-icons";

let apiClient = ApiClient.getDefault();
const {Text} = Typography;

export interface RepaymentPlanProps {
    loanId: number|undefined;
    leadId: number|undefined;
    platform?:string|undefined;
    paidType?: string;
    loanType?: string;
    loanIds?: number[];
}

export default function RepaymentPlan(props: RepaymentPlanProps) {
    const [crudApi, setCrudApi] = useState(undefined as undefined | CrudApi);
    const [showModifyModal, setShowModifyModal] = useState(false);
    const [modifyFormApi, setModifyFormApi] = useState(
        undefined as undefined | FormApi
    );
    const [selectedPlan, setSelectedPlan] = useState({} as any);
    const [modifySaving, setModifySaving] = useState(false);
    const [paidDate, setPaidDate] = useState(null);
    const role = localStorage.getItem("role");
    useEffect(() => {

    }, [])
    let cols: Col[] = [
        {
            name: "ID",
            key: "id",
            hideInEdit: true,
            hideInList: true,
            type: ColType.NUMBER
        },
        {
            name: "贷款ID",
            key: "loanId",
            hideInEdit: true,
            hideInList: true,
            showInFilter: false,
            type: ColType.NUMBER,
        },
        {
            name: "期号",
            key: "periodNo",
            type: ColType.NUMBER,
            showInFilter: true,
            render: (value, record, index) => renderPeriodNo(value, record),
        },
        {
            name: "贷款编号",
            key: "loanNo",
            type: ColType.STRING,
            showInFilter: true,
            hideInList: false,
            hideInCreate: true,
            hideInEdit: true,
        },
        {
            name: "贷款平台",
            key: "platform",
            width: 120,
            type: ColType.STRING,
            showInFilter: false,
            hideInCreate: true,
            hideInEdit: true,
            render: (text: any, record: any) => (
                                        <Tooltip style={{maxWidth:350}} content={renderPlatformTooltip(record)}>
                                            <Typography.Text mark>{text || "-"}</Typography.Text>
                                            
                                        </Tooltip>
                                      ),
        },
        
        {
            name: "应还日期",
            key: "dueDate",
            type: ColType.DATE,
            showInFilter: false,
        },
        {
            name: "应还金额",
            key: "oneTermAmount",
            render: (a) => formatAmountZhCn(a),
            type: ColType.NUMBER
        },
        {
            name: "实际还款金额",
            key: "paidAmount",
            render: (a) => formatAmountZhCn(a),
            type: ColType.NUMBER
        },
        {
            name: "过账金额",
            key: "postingAmount",
            render: (a) => formatAmountZhCn(a),
            type: ColType.NUMBER
        },
        {
            name: "出款人",
            key: "paidUserName",
            type: ColType.SELECT,
            hideInCreate: true,
            render: (value, record, index) => {
                if (record.loanType == 'BORROW') {
                    return (
                        record.borrowerName
                    );
                } else {
                    return value;
                }
            },
        },
        {
            name: "实际还款日期",
            key: "paidDate",
            type: ColType.DATE,
            hideInCreate: true,
        },
        {
                      name: "还款图片",
                      key: "imageUrls",
                      width: 70,
                      type: ColType.STRING,
                      hideInCreate: true,
                      render: (value, record, index) => {
                              if(value){
                                 return    ( <Image
                                          width={50}
                                          height={50}
                                          src={record.imageUrls && record.imageUrls.length > 0 ? record.imageUrls[0].url : ''}
                                          preview={{
                                              src: (record.imageUrls || []).map(item => item.url)
                                          }}
                                      /> )
                                        }else {
                                          return '';
                                        }
                            } 
                    },
        {
            name: "还款天数",
            key: "paidDays",
            type: ColType.NUMBER,
            hideInCreate: true,
        },
        {
            name: "状态",
            key: "status",
            type: ColType.SELECT,
            showInFilter: true,
            hideInEdit: true,
            hideInCreate: true,
            render: (value, record, index) => renderRepaymentPlanStatusTag(value, record),
            getOptions: (row) => Promise.resolve(getRepaymentPlanStatusOpt())
        }
        ,{
            name: "还款方式",
            key: "paidMethod",
            type: ColType.SELECT,
            hideInCreate: true,
            hideInEdit: true,
            showInFilter: true,
            getOptions: (row) => Promise.resolve(getPaidMethodOpt()),
            render: (value: any, row: any, index: number) => displayPaidMethod(value),
           
        }

    ]

    
    const deleteRepaymentPlan = (row: any) => {
        Modal.confirm({
            title: "是否确认删除还款计划?",
            content: "",
            onOk: async () => {
                try {
                    let params = {
                        id: row.id
                    }

                    await apiClient.request(
                        "/repaymentPlan/delete",
                        "POST",
                        null,
                        params
                    );
                    Toast.info("删除成功");

                    crudApi?.refresh();
                } catch (e) {
                }
            },
        });
    }

    const deleteAction: CrudAction = {
        name: "删除",
        action: deleteRepaymentPlan,
    };

    const handleCancelPayment = (row: any) => {
        Modal.confirm({
            title: "是否确认取消还款?",
            content: "",
            onOk: async () => {
                try {
                    let params = {
                        id: row.id
                    }

                    await apiClient.request(
                        "/repaymentPlan/cancelRepayment",
                        "POST",
                        null,
                        params
                    );
                    crudApi?.refresh();

                } catch (e) {
                }
            },
        });
    }

    const cancelPaymentAction: CrudAction = {
        name: "取消还款",
        action: handleCancelPayment,
    };


    const handleModifyClick = async () => {
        setModifySaving(true);
        try {
            await modifyFormApi!.validate();
            let oneTermAmount = modifyFormApi?.getValue("oneTermAmount");
            let paidMethod = modifyFormApi?.getValue("paidMethod");
            let dueDate = modifyFormApi?.getValue("dueDate");
            let params = {
                oneTermAmount:oneTermAmount,
                paidMethod: paidMethod,
                dueDate: typeof dueDate == "string"
                                    ? dueDate
                                    : formatDate(dueDate),
                id: selectedPlan.id
            }

            await apiClient.request(
                "/repaymentPlan/modifyRepaymentPlan",
                "POST",
                null,
                params
            );
            setSelectedPlan({});
            crudApi?.refresh();

            setModifySaving(false);
            setShowModifyModal(false);
        } catch (e) {
            setModifySaving(false);
        }
    };

    const handleModifyButtonClick = (row: any) => {
        setSelectedPlan({id: row.id, oneTermAmount: row.oneTermAmount, paidMethod: row.paidMethod, dueDate: row.dueDate});
        setShowModifyModal(true);
    };

    const modifyAction: CrudAction = {
        name: "修改计划",
        action: handleModifyButtonClick,
    };

    let nowDate = new Date();
    let nowDateStr = formatDate(nowDate);


    return <>
        
        <Modal
            icon={<IconModalStroked size={"extra-large"} style={{ color: 'blue' }}/>}
            style={{width: 600, height: 300}}
            title="修改计划"
            visible={showModifyModal}
            okText="修改"
            confirmLoading={modifySaving}
            onOk={handleModifyClick}
            onCancel={() => setShowModifyModal(false)}
        >
            <Form getFormApi={(formApi) => setModifyFormApi(formApi)}>
                <Form.InputNumber
                    rules={[{required: true, message: "请输入应还金额"}]}
                    initValue={selectedPlan.oneTermAmount}
                    label="应还金额"
                    field="oneTermAmount"
                />
                <Form.DatePicker
                    type="date"
                    rules={[{required: true, message: "请输入应还日期"}]}
                    initValue={selectedPlan.dueDate}
                    field="dueDate"
                    label="应还日期"
                />
                <Form.RadioGroup
                 field="paidMethod"
                 label="还款方式"
                 initValue={selectedPlan.paidMethod}
                >
                   <Form.Radio value="DH" >代还</Form.Radio>
                    <Form.Radio value="KHZH">客户自还</Form.Radio>
            </Form.RadioGroup>
            </Form>
            
        </Modal>
        <Crud
            getCrudApi={(crudApi) => {
                setCrudApi(crudApi);
            }}
            params={{loanId: props.loanId,loanIds: props.loanIds,leadId: props.leadId,platform: props.platform,paidType: props.paidType, loanType: props.loanType}}
            canUpdate={false}
            canCreate={false}
            canDelete={false}
            rowActionWidth={0}
            getRowActions={(a) => {
                let actions = [];
                //------------------------------------------------按钮控制------------------------------------------------------------------
                let isManager = role == "agent" || role == "agent_manager" || role == "op_manager" || role == "monitor" || role == "root";
                if (isManager&&a.status&&a.status !== "YJQ") {
                    //actions.push(modifyAction);
                }
                if (isManager&&a.createdBy&&a.createdBy > 0) {
                    //actions.push(deleteAction);
                }

                return actions;
            }}
            name="还款计划"
            entityKey="repaymentPlan/listAll"
            pageSize={50}
            cols={cols}
        />
    </>
}